import { IssueItemApi } from "api/issuesApi";
import React from "react";

interface TaskCardItemsListProps {
  items?: IssueItemApi[];
  separator?: boolean;
}
export const TaskCardItemsList = ({ items, separator = true }: TaskCardItemsListProps) => {
  if (!items || items.length === 0) {
    return null;
  }
  return (
    <ul className="mt-3">
      {items.map((item) => (
        <li
          key={item.id}
          className={`flex items-center ${separator ? "border-t border-slate-200 dark:border-slate-700 py-2" : "py-1"}`}
        >
          {item.completed ? <GreenCheck /> : <GrayCheck />}
          <div className={`text-sm ${item.completed ? "text-slate-400 dark:text-slate-500 line-through" : ""}`}>
            {item.name}
          </div>
        </li>
      ))}
    </ul>
  );
};

const GreenCheck = () => (
  <svg className="w-3 h-3 shrink-0 fill-current text-emerald-500 mr-2" viewBox="0 0 12 12">
    <path d="M10.28 1.28L3.989 7.575 1.695 5.28A1 1 0 00.28 6.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 1.28z" />
  </svg>
);

const GrayCheck = () => (
  <svg className="w-3 h-3 shrink-0 fill-current text-slate-400 dark:text-slate-500 mr-2" viewBox="0 0 12 12">
    <path d="M10.28 1.28L3.989 7.575 1.695 5.28A1 1 0 00.28 6.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 1.28z" />
  </svg>
);
